import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'
import { Link } from 'react-router-dom'
import LogoRainAnimation from './rain'

export default function About() {
  return (
    <div className='about_bg  lg:h-[1200px] md:h-[900px] h-[700px] flex flex-col justify-center items-center lg:gap-10 lg:px-20 md:px-10 px-4'>
      <div className='-mt-20'>
        <AnimateOnScroll animation='flipIn'>
          <img
            src='/images/about-heading.png'
            alt='about-heading'
            className='md:w-[455px] md:h-[267px] h-[134px] object-contain'
          />
        </AnimateOnScroll>
      </div>
      <div>
        <AnimateOnScroll animation='flipIn'>
          <img
            src='/images/always-fresh-and-delicious.png'
            alt='always-fresh-and-delicious'
            className='md:w-[318px] md:h-[43px] w-[223px] h-[91px] object-contain'
          />
        </AnimateOnScroll>
      </div>

      <p className='w-full max-w-[300px] text-center'>
        <AnimateOnScroll animation='flipIn'>
          Welcome to the home of the Bitcoin Pizza Day Token, where innovation
          and celebration come together! Our token is inspired by one of the
          most iconic moments in cryptocurrency history - the day Bitcoin was
          used to purchase two pizzas for 10,000 BTC. This event, known as
          Bitcoin Pizza Day, marks a pivotal milestone in the journey of digital
          currencies and serves as a reminder of how far we've come.
        </AnimateOnScroll>
      </p>

      <div className='ml-20 mt-5 '>
        <AnimateOnScroll animation='flipIn'>
          <Link
            hrefLang='/'
            className='mt-2 block'
          >
            <img
              src='/images/buy-now.png'
              alt='buy-now'
              className='lg:w-[315px] lg:h-[72px]'
            />
          </Link>
        </AnimateOnScroll>
      </div>
    </div>
  )
}
